import styled from 'styled-components';
import Toast from '../../Common/BaseComponentWrappers/MotifToast';

const StyledMotifToast = styled(Toast)`
	&.toast-message-container {
		position: relative;
		width: calc(95%);
		border-radius: var(--px-12);
		min-height: var(--px-46);
		margin: var(--px-10) auto var(--px-20) !important;
		box-shadow: var(--px-0) var(--px-0) var(--px-10) var(--px-0) rgba(0, 0, 0, 0.2);
		background-color: var(--neutrals-00white);
		--toast--box-shadow: unset;
		--toast--bg-color: unset;
		--toast--color: unset;
		--toast--border-color: unset;
	}
`;

export default StyledMotifToast;
